import React from "react";
import { useTranslation } from "react-i18next";
import { Card, IconButton, Stack, Typography, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";

const BindingItem = ({ item, disabled, onEdit, onDelete }) => {
  const { t } = useTranslation();
  const { getAuthUser } = useJumboAuth();
  const { customer } = getAuthUser();
  const defaultLanguage = customer?.dsokSettings.customer.defaultLanguage;

  return (
    <Card
      sx={{
        p: 2,
        mb: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Stack direction="row" alignItems="center" spacing={2}>
        <div>
          <Typography variant="h4" fontSize={14} mb={0.5}>
            {item.bindingName?.[defaultLanguage] || ""}
          </Typography>
        </div>
      </Stack>
      <Stack direction="row" spacing={1}>
        <Tooltip title={t("buttons.edit", { defaultValue: "Edit" })}>
          <IconButton size="small" disabled={disabled} onClick={onEdit}>
            <EditIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <Tooltip title={t("buttons.delete", { defaultValue: "Delete" })}>
          <IconButton
            size="small"
            disabled={disabled}
            onClick={() => onDelete(item)}
            color="error"
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Stack>
    </Card>
  );
};

export default BindingItem;
